// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"48":"f55b1d7c4f08a4794c72","120":"d7c8883286a7aa6f28c3","392":"af18fe74923cc005a73e","835":"5e7f18fbc2326cbab4d7","856":"99b679371ed852472c23"}[chunkId] + ".min.js";
};